import { Injectable } from '@angular/core';
import { Adapter } from './adapter.service';
import { DataKlinik, DataKlinikV2 } from '../../models/data-klinik.model';

@Injectable({
  providedIn: 'root',
})
export class DataKlinikAdapter implements Adapter<DataKlinik> {
  public adapt(item: any): DataKlinik {
    return new DataKlinik(
      item.id,
      item.uuid,
      item.nama,
      item.alias,
      item.logo,
      item.telepon1,
      item.telepon2,
      item.alamat,
      item.email,
      item.latitude,
      item.longitude,
      item.lokasi,
      item.noRekamMedis,
      item.typePrice,
      item.bayarPendaftaranAwal,
      item.idGroupDataKlinik,
      item.asesmenNyeri,
      item.filterTarifInstallasi,
      item.filterBarangNasabah,
      item.sharingPasien,
      item.pemotonganStok,
      item.noGigiTindakan,
      item.cicilan,
      item.timeZone,
      item.statusBpjs,
      item.statusHargaResep,
      item.kodePpkBpjs,
      item.kunciResepKlinik,
      item.statusInputBiayaAwal,
      item.statusInputTarifTindakan,
      item.statusBayarPendaftaran,
      item.statusHapusKunjungan,
      item.statusStockHabisResep,
      item.statusStockRiwayatResep,
      item.statusCekSipResep,
      item.statusSendAppointmentWhatsapp,
      item.statusBannerSubscriptions,
      item.settingPrintSep,
      item.statusOrderAntrianMedis,
      item.statusFornasResep,
      item.notifikasiResepException,
      item.statusKapasitasDokterDaftarRajal,
      item.statusInputDiagnosaText,
      item.statusTambahCssd,
      item.statusNotifikasiBatalAntrian,
      item.pendaftaranDisabled,
      item.pendaftaranDisabledException,
      item._embedded
    );
  }

  public adaptV2(item: any, klinikMaker?: any): DataKlinikV2 {
    return {
      id: item?.id ? item.id : item.idDataKlinik,
      uuid: item.uuid,
      kodeDataKlinik: item.kodeDataKlinik,
      namaOwner: item.namaOwner,
      nama: item.nama,
      alias: item.namaAlias,
      url: item.url,
      url2: item.url2,
      lokasi: item.lokasi,
      logo: item.logo,
      telepon1: item.noTelp,
      telepon2: item.noTelp2,
      alamat: item.alamat,
      email: item.email,
      instagram: item.instagram,
      twitter: item.twitter,
      facebook: item.facebook,
      linkedin: item.linkedin,
      website: item.website,
      latitude: item.latitude,
      longitude: item.longitude,
      noRekamMedis: item.noRekamMedis,
      typePrice: item.typePrice,
      idGroupDataKlinik: item.idGroupDataKlinik,
      sharingPasien: item.sharingPasien,
      rangeVoid: item.rangeVoid,
      deskripsi: item.deskripsi,
      timeZone: item.timeZone,
      typeFarmasi: item.typeFarmasi,
      strukPos: item.strukPos,
      strukKasir: item.strukKasir,
      metodeDiskon: item.metodeDiskon,
      hargaSatuan: item.hargaSatuan,
      diskonPos: item.diskonPos,
      anamnesis: item.anamnesis,
      pemeriksaanPenunjang: item.pemeriksaanPenunjang,
      masalahMedis: item.masalahMedis,
      tindakanParameter: item.tindakanParameter,
      cicilan: item.cicilan,
      asesmenNyeri: item.asesmenNyeri,
      filterTarifInstalasi: item.filterTarifInstallasi,
      icd10: item.icd10,
      icd10Gigi: item.icd10Gigi,
      icd9Cm: item.icd9Cm,
      tindakanMinmed: item.tindakanMinmed,
      delivery: item.delivery,
      noGigiTindakan: item.noGigiTindakan,
      questionTindakan: item.questionTindakan,
      pemeriksaanVital: item.pemeriksaanVital,
      kodePpkBpjs: item.kodePpkBpjs,
      bayarPendaftaranAwal: item.bayarPendaftaranAwal,
      pemotonganStok: item.pemotonganStok,
      idKategoriKlinik: item.idKategoriKlinik,
      urlBpjs: item.urlBpjs,
      statusInputTindakan: item.statusInputTindakan,
      statusInputResep: item.statusInputResep,
      filterBarangNasabah: item.filterBarangNasabah,
      statusBpjs: item.statusBpjs,
      statusHargaResep: item.statusHargaResep,
      kunciResepKlinik: item.kunciResepKlinik,
      statusInputBiayaAwal: item.statusInputBiayaAwal,
      statusInputTarifTindakan: item.statusInputTarifTindakan,
      statusBayarPendaftaran: item.statusBayarPendaftaran,
      ttsSpeakingRate: item.ttsSpeakingRate,
      statusQtyTindakan: item.statusQtyTindakan,
      statusAppointmentMobile: item.statusAppointmentMobile,
      consIdBpjs: item.consIdBpjs,
      passwordBpjs: item.passwordBpjs,
      userKeyBpjs: item.userKeyBpjs,
      statusHapusKunjungan: item.statusHapusKunjungan,
      regional: item.regional,
      tipeFaskes: item.tipeFaskes,
      kelasFaskes: item.kelasFaskes,
      nominalKlaimInacbg: item.nominalKlaimInacbg,
      nominalKlaimInacbgRajal: item.nominalKlaimInacbgRajal,
      totalJamKerjaAbsen: item.totalJamKerjaAbsen,
      statusTuslah: item.statusTuslah,
      statusRadiusInputCppt: item.statusRadiusInputCppt,
      foto1: item.foto1,
      sharingStock: item.sharingStock,
      statusStockHabisResep: item.statusStockHabisResep,
      statusStockRiwayatResep: item.statusStockRiwayatResep,
      bannerImage: item.groupBanner,
      statusHapusRujukan: item.statusHapusRujukan,
      statusCekSipResep: item.statusCekSipResep,
      statusSendAppointmentWhatsapp: item.statusSendAppointmentWhatsapp,
      statusBannerSubscriptions: item.statusBannerSubscriptions,
      settingPrintSep: item.settingPrintSep,
      statusOrderAntrianMedis: item.statusOrderAntrianMedis,
      statusFornasResep: item.statusFornasResep,
      notifikasiResepException: item.notifikasiResepException,
      statusKapasitasDokterDaftarRajal: item.statusKapasitasDokterDaftarRajal,
      statusEditHargaTindakanMedis: item.statusEditHargaTindakanMedis,
      statusStickyHeaderMedis: item.statusStickyHeaderMedis,
      statusInputDiagnosaText: item.statusInputDiagnosaText,
      statusTambahCssd: item.statusTambahCssd,
      statusNotifikasiBatalAntrian: item.statusNotifikasiBatalAntrian,
      pendaftaranDisabled: item.pendaftaranDisabled,
      pendaftaranDisabledException: item.pendaftaranDisabledException,
      klinikMaker: {
        idKaryawan: klinikMaker?.idKaryawan,
        fotoIdentitas: klinikMaker?.fotoIdentitas,
      },
      statusBatalPasienOtomatis: item.statusBatalPasienOtomatis,
      statusSelesaiPasienOtomatis: item.statusSelesaiPasienOtomatis,
    };
  }
}
